/**
 * Grouping rules for organization invitations.
 *
 * An invite is "outstanding" while it has not been settled — accepted or
 * cancelled by an admin, or declined by the invitee. Outstanding invites split
 * by whether their link still works: a pending invite is actionable (copy the
 * link, resend, revoke), an expired one is not — its link is dead, so it can
 * only be resent or deleted.
 */

export interface InviteLike {
  status: string;
  expires_at: string;
}

export interface InviteGroups<T extends InviteLike> {
  pending: T[];
  expired: T[];
}

export function partitionInvites<T extends InviteLike>(
  invites: T[] | undefined | null,
  now: Date = new Date()
): InviteGroups<T> {
  const pending: T[] = [];
  const expired: T[] = [];

  for (const invite of invites ?? []) {
    if (
      invite.status === "accepted" ||
      invite.status === "cancelled" ||
      invite.status === "declined"
    ) {
      continue;
    }
    if (new Date(invite.expires_at).getTime() < now.getTime()) {
      expired.push(invite);
    } else {
      pending.push(invite);
    }
  }

  return { pending, expired };
}
